import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import SVG from 'react-inlinesvg';
import { Drawer, List, Tag, Button, Dropdown, Menu } from 'antd';
import {
  DownOutlined,
} from '@ant-design/icons';
import { baseFonts } from '../../components/editor/fonts';


export class FontDrawer extends React.Component {
  static propTypes = {
    visible: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    currentFont: PropTypes.object.isRequired,
    fontSelected: PropTypes.func.isRequired,
  };


  menu = (font) => (
    <Menu theme="dark">
      <Menu.Item key={font.name} onClick={() => this.props.fontSelected(font)}>
        Use font scheme "{font.name}"
      </Menu.Item>
    </Menu>
  );

  renderItem = (font) => {
    const { family, weight } = font;
    const isSelected = (this.props.currentFont.name === font.name);

    const svgSrcHeading = require(`assets/media/editor/font/${family[0]}-${weight[0]}.svg`);
    const svgSrcSubheading = require(`assets/media/editor/font/${family[1]}-${weight[1]}.svg`);
    const svgSrcText = require(`assets/media/editor/font/${family[2]}-${weight[2]}.svg`);

    return (
      <div className={cx('font__card bg-white rounded-sm shadow-sm mb-3 p-0', {
        selected: isSelected,
      })}>
        { isSelected ? (
          <div className="bg-primary small text-center text-white">CURRENT</div>
        ): null}

        <div className="p-2">

          <div className="mb-2">
            <Dropdown
              overlay={this.menu(font)}
              placement="bottomRight" trigger={["click"]}
            >
              <div className="font__name d-flex w-100 align-items-center text-primary justify-content-center">
                {font.name}
                <DownOutlined className="ml-2" />
              </div>
            </Dropdown>
          </div>

          <div className="d-flex flex-column">
            <div className="d-flex flex-row justify-content-between align-items-end">
              <SVG src={svgSrcHeading} />
              <div className="text-muted small">header</div>
            </div>
          </div>

          <div className="d-flex flex-column">
            <div className="d-flex flex-row justify-content-between align-items-end">
              <SVG src={svgSrcSubheading} style={{ transform: "scale(0.82)", transformOrigin: "left"}} />
              <div className="text-muted small">sub-head</div>
            </div>
          </div>

          <div className="d-flex flex-column">
            <div className="d-flex flex-row justify-content-between align-items-end">
              <SVG src={svgSrcText} style={{ transform: "scale(0.7)", transformOrigin: "left"}} />
              <div className="text-muted small">text</div>
            </div>
          </div>

        </div>

      </div>
    );
  };


  render() {
    return (
      <div>
        <Drawer
          title="Choose Fonts"
          placement="right"
          className="editor__drawer font__drawer"
          closable={true}
          onClose={this.props.onClose}
          visible={this.props.visible}
          destroyOnClose={true}
          width={300}
        >
          <List
            split={true}
            itemLayout="horizontal"
            dataSource={baseFonts}
            renderItem={this.renderItem}
          />
        </Drawer>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./scripts/components/editor/FontDrawer.jsx